/**
 * Parse a raw User-Agent string into a short, human-readable summary.
 * Returns null when the input is empty.
 */
export function parseUserAgent(ua) {
  const raw = String(ua || "").trim();
  if (!raw) return null;

  const lower = raw.toLowerCase();

  let browser = "Unknown browser";
  if (lower.includes("edg/") || lower.includes("edgios/") || lower.includes("edga/")) {
    browser = "Edge";
  } else if (lower.includes("opr/") || lower.includes("opera")) {
    browser = "Opera";
  } else if (lower.includes("chrome/") && !lower.includes("edg/")) {
    browser = "Chrome";
  } else if (lower.includes("firefox/") || lower.includes("fxios/")) {
    browser = "Firefox";
  } else if (lower.includes("safari/") && !lower.includes("chrome/") && !lower.includes("chromium/")) {
    browser = "Safari";
  } else if (lower.includes("msie") || lower.includes("trident/")) {
    browser = "Internet Explorer";
  }

  let os = "Unknown OS";
  if (lower.includes("android")) os = "Android";
  else if (lower.includes("iphone") || lower.includes("ipad") || lower.includes("ipod") || lower.includes("ios")) {
    os = lower.includes("ipad") ? "iPadOS" : "iOS";
  } else if (lower.includes("windows")) os = "Windows";
  else if (lower.includes("mac os") || lower.includes("macintosh")) os = "macOS";
  else if (lower.includes("linux")) os = "Linux";
  else if (lower.includes("cros")) os = "Chrome OS";

  let deviceType = "Desktop";
  if (lower.includes("ipad") || (lower.includes("android") && !lower.includes("mobile") && lower.includes("tablet"))) {
    deviceType = "Tablet";
  } else if (
    lower.includes("mobi") ||
    lower.includes("iphone") ||
    lower.includes("ipod") ||
    lower.includes("android")
  ) {
    deviceType = "Mobile";
  }

  return {
    browser,
    os,
    deviceType,
    summary: `${browser} on ${os} (${deviceType})`,
    raw,
  };
}
